import React from "react";
import PropTypes from "prop-types";

import FormGroup from "@mui/material/FormGroup";

import LookInput from "../../../ui/lookInput";
import {getShippingValidationErrors} from "./shippingValidation";
import LookAddressInput from "../../../ui/lookAddressInput";
import WithInputValidations from "../../../hocs/withInputValidations";


const GroheBillingAndShippingInputs = (props) => {

  const {addressObject, setAddressInfo, setAddressErrors, addressErrors, shouldSetCountry} = props;

  const shippingInputChange = (property, value) => {
    setAddressInfo(property, value);
  }

  return (
    <WithInputValidations>
      {(inputsValidated, updateInputValidations) => (
        <FormGroup className="gc-form gc-form--row">
          {Object.keys(addressObject).map(inputKey => {
            if (inputKey === "stateShort") {
              return null
            }
            if (inputKey === "address1") {
              return (
                <div className="gc-form__inputs-block" key={inputKey}>
                  <LookAddressInput property={inputKey}
                                    shouldSetCountry={shouldSetCountry}
                                    updateInputValidations={updateInputValidations}
                                    inputsValidated={inputsValidated}
                                    inputValue={addressObject[inputKey]}
                                    setInputValue={shippingInputChange}
                                    getValidationErrors={getShippingValidationErrors}
                                    errorsObject={addressErrors}
                                    changeErrorsObject={setAddressErrors}
                                    isRequired={true} />
                </div>
              )
            }
            return (
              <div className="gc-form__inputs-block" key={inputKey}>
                <LookInput property={inputKey}
                           name={inputKey}
                           inputsValidated={inputsValidated}
                           inputValue={addressObject[inputKey]}
                           setInputValue={shippingInputChange}
                           getValidationErrors={getShippingValidationErrors}
                           errorsObject={addressErrors}
                           changeErrorsObject={setAddressErrors}
                           isRequired={false}/>
              </div>
            )
          })}
        </FormGroup>
      )}
    </WithInputValidations>
  )
};

GroheBillingAndShippingInputs.propTypes = {
  addressObject: PropTypes.object.isRequired,
  setAddressInfo: PropTypes.func.isRequired,
  addressErrors: PropTypes.object,
  setAddressErrors: PropTypes.func,
}

export default GroheBillingAndShippingInputs
